import { ApiProperty, PartialType } from './decorators-nest';
import { IsDateString, IsNumber, IsEnum, IsOptional, IsString, IsArray, ArrayNotEmpty } from 'class-validator';

export class MenstrualCycleDto {
  @ApiProperty({
    description: 'Patient ID',
    required: true,
    example: 'uuid',
  })
  @IsString()
  public patientId: string;

  @ApiProperty({
    type: 'string',
    format: 'date',
    example: '2025-09-07',
    required: true,
    description: 'Date of the health record',
  })
  @IsDateString()
  cycleStart: string;

  @IsOptional()
  @ApiProperty({
    type: 'number',
    format: 'number',
    example: 5,
    required: false,
    description: 'Duration of period cycle',
  })
  @IsNumber()
  duration?: number;
}
